import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AccountSwitcherHost } from '@src/components/AccountSwitcher/AccountSwitcherHost';
import { Spinner } from '@src/components';
import { useAppSelector } from '@src/state/hooks';
import { LOGIN_PATH } from '@src/routing/routes';
import { FullPageShell } from '@src/components/FullPageShell/FullPageShell';
import './ProfilesPage.css';

export function ProfilesPage() {
  const { t } = useTranslation();
  const { user, status } = useAppSelector((state) => state.session);
  if (status === 'idle' || status === 'loading') return <Spinner label={t('box.loading')} />;
  if (!user) return <Navigate to={LOGIN_PATH} replace />;
  return (
    <FullPageShell
      title={t('switcher.title')}
      className="profiles-page"
      testId="profiles-page"
      backTestId="profiles-back"
    >
      <AccountSwitcherHost session={user} fullPage />
    </FullPageShell>
  );
}
